<template>
  <div>
    <v-menu offset-y open-on-hover>
      <hg-account-button slot="activator" :hg-user="hgUser" />
      <hg-menu-list />
    </v-menu>
  </div>
</template>

<script>
import MenuList from './MenuList.vue';
import AccountButton from './AccountButton.vue';

export default {
  props: {
    hgUser: {
      required: false,
      type: Object,
    },
  },
  components: {
    'hg-menu-list': MenuList,
    'hg-account-button': AccountButton,
  },
};
</script>
